import BaseEndScreenMediator from "../../../../../shared/src/ranj/equalture/view/BaseEndScreenMediator";

export default class EndScreenMediator extends BaseEndScreenMediator {

    constructor(target, dispatcher, languagePack, layoutManager, soundManager, appModel) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, appModel);
    }
};